import { requestS3URLBinary } from '../../../../../services/web-api-client';
import { extractFeatureAndBatchTable } from '../feature-table';
import { extractCesiumContentHeader } from '../header';
import { CesiumPnts } from './types';

/**
 *  Returns the point data loaded from the Cesium pnts file specified in pointCloudId and path
 *  https://github.com/CesiumGS/3d-tiles/tree/master/specification/TileFormats/PointCloud
 */
export const loadCesiumPnts = async (data: string | ArrayBuffer): Promise<CesiumPnts> => {
  let pntsBuffer: ArrayBuffer;
  if (typeof data === 'string') {
    const response = await requestS3URLBinary(data);
    pntsBuffer = response.data;
  } else {
    pntsBuffer = data;
  }

  const pntsHeader = extractCesiumContentHeader(pntsBuffer);
  return {
    header: pntsHeader,
    features: extractFeatureAndBatchTable(pntsBuffer, pntsHeader),
  };
};
